import api from './api';

/**
 * @param {string} assetId
 * @param {string} transcript
 * @returns {Promise<{
 *  audio_id: string
 *  transcript: string
 *  created_at: string
 *  updated_at: string
 *  is_asset_audio_updated: boolean
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Assets-PutAssetAudio
 */
export default async function updateAudioTranscript(assetId, transcript) {
    const { data } = await api.put(`assets/${assetId}`, {
        // Null is preferred over empty string
        transcript: transcript || null
    });

    return data;
}